'use client'

import { NavigationQueryResult } from '@repo/sanity/types'
import { Button } from '@repo/ui/components/button'
import { cn } from '@repo/ui/lib/utils'
import { FunctionComponent, useEffect, useState } from 'react'
import { useNavigation } from '../../../providers/NavigationProvider'
import { SHEET, useSheet } from '../../../providers/SheetProvider'
import { useWishlist } from '../../../providers/WishlistProvider'
import { PageDto } from '../../../types/page.types'

interface Props {
  pageDto: PageDto
  navigation: NavigationQueryResult
}

const WishlistTriggerButton: FunctionComponent<Props> = ({ pageDto, navigation }) => {
  const { openSheet } = useSheet()
  const { shouldUseInverse } = useNavigation()
  const { wishlist } = useWishlist()
  const qty = wishlist.length
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <li>
      <Button
        className='relative hidden lg:inline-flex'
        variant={shouldUseInverse(navigation) ? 'navigationInverse' : 'navigationDefault'}
        onClick={() => openSheet(SHEET.WISHLIST)}
      >
        {pageDto.dictionary?.wishlist?.wishlist || 'Wishlist'}
        <span
          inert={!(isClient && qty > 0)}
          aria-label={isClient && qty > 0 ? qty.toString() : undefined}
          className={cn(
            'bg-miista-green-500 absolute right-1 top-1 block size-1 rounded-full opacity-0 transition-opacity duration-300 ease-out',
            isClient && qty > 0 && 'opacity-100',
          )}
        />
      </Button>
    </li>
  )
}

export default WishlistTriggerButton
